import classes from './FormRedirect.module.scss';
import { useRouter } from 'next/router';

export default function FormRedirect({ ticketId }) {
    const router = useRouter();
    const handleClick = (e) => {
        e.preventDefault();
        router.reload('/contact-us/');
    };
    return (
        <div className={classes.oUnsubscribedBlock}>
            {!ticketId ? (
                <div className={classes.oSubmitted}>
                    <figure className={classes.mIcon}>
                        <svg
                            width="68"
                            height="68"
                            viewBox="0 0 68 68"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M53.125 59.5H14.875C14.3114 59.5 13.7709 59.2761 13.3724 58.8776C12.9739 58.4791 12.75 57.9386 12.75 57.375V10.625C12.75 10.0614 12.9739 9.52091 13.3724 9.1224C13.7709 8.72388 14.3114 8.5 14.875 8.5H40.375L55.25 23.375V57.375C55.25 57.9386 55.0261 58.4791 54.6276 58.8776C54.2291 59.2761 53.6886 59.5 53.125 59.5Z"
                                stroke="white"
                                strokeWidth="4.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M40.375 8.5V23.375H55.25"
                                stroke="white"
                                strokeWidth="4.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M27.625 34L40.375 46.75"
                                stroke="white"
                                strokeWidth="4.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M40.375 34L27.625 46.75"
                                stroke="white"
                                strokeWidth="4.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </figure>
                    <h2 className={`${classes.aTitle} fnt46`}>
                        Ooops. Something went wrong with your request.
                    </h2>
                </div>
            ) : (
                <div className={classes.oSubmitted}>
                    <h2 className={`${classes.aTitle} fnt46`}>
                        Thanks for your inquiry. We will reply back shortly.
                    </h2>
                </div>
            )}

            <div className={`${classes.oCtaWrapper}`}>
                <span className={`${classes.mBtn}`}>
                    <span className={`${classes.aText} fnt18f`}>
                        {ticketId ? 'Send another inquiry' : 'Try again'}
                    </span>
                    <input
                        type="submit"
                        value={''}
                        className={classes.inputClick}
                        onClick={handleClick}
                    />
                </span>
            </div>
        </div>
    );
}
